module.exports = __webpack_public_path__ + "img/grafana.d66da9f6.png";